import { pickBy } from "lodash";

/**
 * Checks if a saved list record is an Express Enroll list.
 * Express Enroll lists have the expressEnrollEligible filter set to true.
 *
 * @param {Object} record - The saved list record
 * @param {string|Object} record.params - The params containing filters (can be JSON string or object)
 * @returns {boolean} True if the list is an Express Enroll list
 */
export const isExpressEnrollList = (record) => {
  try {
    const params = typeof record?.params === "string" ? JSON.parse(record?.params) : record?.params;
    return params?.filters?.expressEnrollEligible === true;
  } catch {
    return false;
  }
};

/**
 * Keeps only the saved facilities whose value is in the accessible-facility id set, preserving the
 * original object keys.
 *
 * Callers must NOT invoke this when the accessible set is unknown (providers not loaded or failed to
 * load) — an empty set would drop every facility and widen the patient search to all patients.
 *
 * @param {Object} savedFacilities - The saved facilities map, keyed by index: { key: { value, text } }
 * @param {Set<number>} accessibleFacilityIds - The set of facility ids the user currently has access to
 * @returns {Object} A new facilities map containing only the accessible entries
 */
export const pruneSavedFacilitiesByAccessible = (savedFacilities, accessibleFacilityIds) =>
  pickBy(savedFacilities, (facility) => accessibleFacilityIds.has(facility.value));
